// Module
var code = "<rd-widget>\n  <rd-widget-header icon=\"sliders\" title-text=\"User theme\"></rd-widget-header>\n  <rd-widget-body>\n    <form class=\"form-horizontal\">\n      <box-selector radio-name=\"'theme'\" value=\"$ctrl.state.themeColor\" options=\"$ctrl.state.availableThemes\" on-change=\"($ctrl.setThemeColor)\"></box-selector>\n    </form>\n  </rd-widget-body>\n</rd-widget>\n";
// Exports
var _module_exports = code;;
var path = 'app/portainer/components/theme/theme-settings.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;